// import { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import { useAuth } from '../../../context/AuthContext';
// import { Box, Grid, Paper, Typography, Button, TextField, CircularProgress, Autocomplete, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, CardContent, useMediaQuery, useTheme, Dialog, DialogContent } from '@mui/material';
// import { Snackbar, Alert } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import CityPopupModal from '../../../components/CityPopupModal';
// import ConsigneeMaster from '../../ConsigneeMaster';

// export default function ConsignerDetails({ initialData = {}, connectionString, clientData, onChange }) {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const API = connectionString;
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     // ─── Ship‑From/To Autocomplete ───────────────────────────────────────
//     const [shipFrom, setShipFrom] = useState(initialData?.shipFrom || null);
//     const [shipTo, setShipTo] = useState(initialData?.shipTo || null);
//     const [fromOptions, setFromOptions] = useState([]);
//     const [toOptions, setToOptions] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [openConsigneePopup, setOpenConsigneePopup] = useState(false);


//     // ─── “Add New Client” Popup ────────────────────────────────────────
//     const [openPopup, setOpenPopup] = useState(false);
//     const [popupSource, setPopupSource] = useState('from'); // 'from' | 'to'

//     // ─── Popup Autocomplete (party) state ─────────────────────────────
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [partyName, setPartyName] = useState('');
//     const [suggestions, setSuggestions] = useState([]);
//     const [selectedParty, setSelectedParty] = useState(null);

//     // ─── City Autocomplete ────────────────────────────────────────────
//     const [cityQuery, setCityQuery] = useState('');
//     const [cityResults, setCityResults] = useState([]);
//     const [showResults, setShowResults] = useState(false);
//     const [selectedCity, setSelectedCity] = useState(null);
//     const [showCityModal, setShowCityModal] = useState(false);

//     const [snackOpen, setSnackOpen] = useState(false);
//     const [snackMessage, setSnackMessage] = useState('');

//     const initializedRef = useRef(false);

//     // ─── New‑Party Form inside Popup ─────────────────────────────────
//     const [form, setForm] = useState({
//         PartyID: '', ConName: '', Address: '',
//         Pincode: '', Distance: '', GSTNO: '',
//         PANNo: '', ContactPerson: '', Mobile: '',
//         Email: '', City: '', State: '',
//         stateCode: '', country: ''
//     });
//     const [errors, setErrors] = useState({});

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     // ─── Fetch suggestions for pop-up client search ───────────────────────────
//     const fetchShipOptions = async (q, setter) => {
//         if (!openPopup) return;
//         setLoading(true);
//         try {
//             const res = await axios.get(`${API}/api/company-search`, { params: { field: 'companyName', companyName: q, companyId } });
//             setter(res.data.data || []);
//         } catch {
//             setter([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ─── Fetch city list ──────────────────────────────────────────────
//     useEffect(() => {
//         if (!cityQuery || !showResults) {
//             setCityResults([]);
//             return;
//         }
//         let active = true;
//         axios.get(`${API}/api/get-cities`, { params: { query: cityQuery } })
//             .then(res => { if (active) setCityResults(res.data.cities || []); })
//             .catch(() => { if (active) setCityResults([]); });
//         return () => { active = false; };
//     }, [cityQuery, showResults]);

//     // // ─── Initialize shipFrom and shipTo from initialData ──────────────
//     // useEffect(() => {
//     //     if (initialData?.shipFrom && Object.keys(initialData.shipFrom).length > 0) {
//     //         setShipFrom(initialData.shipFrom);
//     //         setFromOptions((prev) => {
//     //             const exists = prev?.some(opt => opt.id === initialData.shipFrom.id);
//     //             return exists ? prev : [initialData.shipFrom, ...prev];
//     //         });
//     //     }

//     //     if (initialData?.shipTo && Object.keys(initialData.shipTo).length > 0) {
//     //         setShipTo(initialData.shipTo);
//     //         setToOptions((prev) => {
//     //             const exists = prev?.some(opt => opt.id === initialData.shipTo.id);
//     //             return exists ? prev : [initialData.shipTo, ...prev];
//     //         });
//     //     }
//     // }, [initialData]);

//     // ─── INIT FROM initialData (EDIT MODE SAFE) ───────────────
//     useEffect(() => {
//         if (initializedRef.current) return;

//         if (initialData?.shipFrom) {
//             setShipFrom(initialData.shipFrom);
//             setFromOptions(prev =>
//                 prev.some(o => o.id === initialData.shipFrom.id)
//                     ? prev
//                     : [initialData.shipFrom, ...prev]
//             );
//         }

//         if (initialData?.shipTo) {
//             setShipTo(initialData.shipTo);
//             setToOptions(prev =>
//                 prev.some(o => o.id === initialData.shipTo.id)
//                     ? prev
//                     : [initialData.shipTo, ...prev]
//             );
//         }

//         initializedRef.current = true;
//     }, [initialData]);

//     // ─── Handlers to open/close the “Add New Client” popup ─────────────
//     const openAddPopup = (which) => {
//         setPopupSource(which);
//         setForm({ PartyID: '', ConName: '', Address: '', Pincode: '', Distance: '', GSTNO: '', PANNo: '', ContactPerson: '', Mobile: '', Email: '', City: '', State: '', stateCode: '', country: '' });
//         setSelectedParty(null);
//         setSelectedCity(null);
//         setErrors({});
//         setDropdownOpen(false);
//         setPartyName('');
//         setCityQuery('');
//         setShowResults(false);
//         setOpenPopup(true);
//     };
//     const closePopup = () => setOpenPopup(false);

//     // ─── Typing consignee & consigner Autocomplete ───────────────────────
//     const fetchPopupSuggestions = async (q) => {
//         if (!q) return [];
//         try {
//             const res = await axios.get(`${API}/api/data/retrive`, { params: { mode: 'client', companyName: q, clientId: clientData.clientId, companyId } });
//             return res.data || [];
//         } catch {
//             return [];
//         }
//     };

//     // ─── User picks one of the popup suggestions (or “➕ Add New Client”) ─
//     const handlePartyChange = (_, newVal) => {
//         if (newVal?.id === 'add-new') {
//             setSelectedParty(null);
//             setForm(f => ({ ...f, ConName: '' }));
//         } else {
//             setSelectedParty(newVal);
//             setForm({
//                 PartyID: newVal.id,
//                 ConName: newVal.clientname,
//                 Address: newVal.Address || '',
//                 Pincode: newVal.Pincode || '',
//                 Distance: newVal.Distance || '',
//                 GSTNO: newVal.gstno || '',
//                 PANNo: newVal.PANNo || '',
//                 ContactPerson: newVal.ContactPerson || '',
//                 Mobile: newVal.mobileNo || '',
//                 Email: newVal.emailId || '',
//                 City: newVal.City || '',
//                 State: newVal.State || '',
//                 stateCode: newVal.stateCode || '',
//                 country: newVal.Country || ''
//             });
//             setSelectedCity({
//                 city: newVal.City || '',
//                 state: newVal.State || '',
//                 stateCode: newVal.stateCode || '',
//                 country: newVal.Country || ''
//             });
//         }
//     };

//     // ─── Form field change & City selector ────────────────────────────
//     const handleFormChange = key => e => { setForm(f => ({ ...f, [key]: e.target.value })); };
//     const handleCitySelect = (c) => {
//         setSelectedCity(c);
//         setForm(f => ({
//             ...f,
//             City: c.city,
//             State: c.state,
//             stateCode: c.stateCode,
//             country: c.country
//         }));
//         setShowResults(false);
//     };

//     // ─── Save new party to server ─────────────────────────────────────
//     const handleSave = async () => {
//         const errs = {};
//         if (!form.ConName) errs.ConName = 'Required';
//         if (form.Mobile && !/^\d{10}$/.test(form.Mobile)) errs.Mobile = 'Must be 10 digits';
//         if (form.Email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.Email)) errs.Email = 'Invalid email';
//         if (form.Pincode && !/^\d{6}$/.test(form.Pincode)) errs.Pincode = 'Must be 6 digits';
//         if (form.GSTNO && form.GSTNO.length > 15) errs.GSTNO = 'Max 15 chars';
//         if (Object.keys(errs).length) {
//             setErrors(errs);
//             return;
//         }

//         const payload = { ...form, Distance: form.Distance || '0', companyId: companyId || '', userId: userId || '' };

//         try {
//             const r = await axios.post(`${API}/api/consignee/insert`, payload);
//             const list = await fetchPopupSuggestions(form.ConName);
//             if (popupSource === 'from') {
//                 setFromOptions(list);
//                 const newShipFrom = list.find(o => o.clientname === form.ConName) || null;
//                 setShipFrom(newShipFrom);
//                 // if (newShipFrom) {
//                 //     // onNext({ shipFrom: newShipFrom, shipTo });
//                 // }
//             } else {
//                 setToOptions(list);
//                 const newShipTo = list.find(o => o.clientname === form.ConName) || null;
//                 setShipTo(newShipTo);
//                 // if (newShipTo) {
//                 //     onNext({ shipFrom, shipTo: newShipTo });
//                 // }
//             }
//             closePopup();
//         } catch (err) {
//             console.error(err);
//             setSnackMessage('Failed to save consignee.');
//             setSnackOpen(true);
//         }
//     };

//     // ─── Handle Next button click ─────────────────────────────────────
//     // const handleNextClick = () => {
//     //     if (!shipFrom || !shipTo) {
//     //         setSnackMessage('Please select both Ship From and Ship To.');
//     //         setSnackOpen(true);
//     //         return;
//     //     }

//     //     const fullShipFrom = {
//     //         id: shipFrom?.id || '',
//     //         clientname: shipFrom?.clientname || '',
//     //         Address: shipFrom?.Address || '',
//     //         gstno: shipFrom?.gstno || '',
//     //         City: shipFrom?.City || '',
//     //         State: shipFrom?.State || '',
//     //         mobileNo: shipFrom?.mobileNo || '',
//     //         emailId: shipFrom?.emailId || '',
//     //         ContactPerson: shipFrom?.ContactPerson || ''
//     //     };

//     //     const fullShipTo = {
//     //         id: shipTo?.id || '',
//     //         clientname: shipTo?.clientname || '',
//     //         Address: shipTo?.Address || '',
//     //         gstno: shipTo?.gstno || '',
//     //         City: shipTo?.City || '',
//     //         State: shipTo?.State || '',
//     //         mobileNo: shipTo?.mobileNo || '',
//     //         emailId: shipTo?.emailId || '',
//     //         ContactPerson: shipTo?.ContactPerson || ''
//     //     };

//     //     onNext({ shipFrom: fullShipFrom, shipTo: fullShipTo });
//     // };

//     // ─── PUSH DATA TO PARENT (IMPORTANT PART) ─────────────────
//     useEffect(() => {
//         // if (!shipFrom && !shipTo) return;

//         onChange?.({
//             shipFrom: {
//                 id: shipFrom?.id,
//                 clientname: shipFrom?.clientname,
//                 Address: shipFrom?.Address,
//                 gstno: shipFrom?.gstno,
//                 City: shipFrom?.City,
//                 State: shipFrom?.State,
//                 mobileNo: shipFrom?.mobileNo,
//                 emailId: shipFrom?.emailId,
//                 ContactPerson: shipFrom?.ContactPerson
//             },
//             shipTo: {
//                 id: shipTo?.id,
//                 clientname: shipTo?.clientname,
//                 Address: shipTo?.Address,
//                 gstno: shipTo?.gstno,
//                 City: shipTo?.City,
//                 State: shipTo?.State,
//                 mobileNo: shipTo?.mobileNo,
//                 emailId: shipTo?.emailId,
//                 ContactPerson: shipTo?.ContactPerson
//             }
//         });
//     }, [shipFrom?.id, shipTo?.id]);


//     // ─── Fetch initial shipFrom and shipTo options on mount ───────────
//     useEffect(() => {
//         const fetchInitialOptions = async () => {
//             try {
//                 const response = await axios.get(`${API}/api/data/retrive`, { params: { mode: 'client', companyId, clientId: clientData.clientId } });
//                 const data = response.data || [];
//                 setFromOptions(data);
//                 setToOptions(data);
//             } catch (err) {
//                 console.error('Error fetching initial options:', err);
//             }
//         };
//         fetchInitialOptions();
//     }, []);

//     return (
//         <Paper sx={{ p: 1, mt: -1.5 }}>
//             <Grid container spacing={2}>
//                 {['from', 'to'].map(src => (
//                     <Grid item size={{ xs: 12, sm: 6 }} key={src}>
//                         <Typography variant="subtitle1" mb={1}>
//                             Ship {src === 'from' ? 'From (Consigner)' : 'To (Consignee)'}
//                         </Typography>

//                         <Autocomplete
//                             fullWidth
//                             freeSolo
//                             options={src === 'from' ? (shipFrom ? [shipFrom, ...fromOptions.filter(o => o.id !== shipFrom.id)] : fromOptions) : (shipTo ? [shipTo, ...toOptions.filter(o => o.id !== shipTo.id)] : toOptions)}
//                             getOptionLabel={opt => typeof opt === 'string' ? opt : opt.clientname || ''}
//                             value={src === 'from' ? shipFrom : shipTo}
//                             loading={loading}
//                             onInputChange={async (_, v) => {
//                                 const results = await fetchPopupSuggestions(v);
//                                 if (src === 'from') {
//                                     setFromOptions(results);
//                                 } else {
//                                     setToOptions(results);
//                                 }
//                             }}
//                             onChange={(_, val) => src === 'from' ? setShipFrom(val) : setShipTo(val)}
//                             slotProps={{ popper: { sx: { zIndex: 100 } } }}
//                             renderInput={(params) => (
//                                 <TextField
//                                     {...params}
//                                     size="small"
//                                     // required
//                                     label={`Select Ship ${src === 'from' ? 'From' : 'To'}`}
//                                     InputProps={{
//                                         ...params.InputProps,
//                                         endAdornment: (
//                                             <>
//                                                 {loading && <CircularProgress size={20} />}
//                                                 {params.InputProps.endAdornment}
//                                             </>
//                                         ),
//                                     }}
//                                     InputLabelProps={{ sx: requiredAsteriskStyle }}
//                                     sx={{
//                                         '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                         '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                     }}
//                                 />
//                             )}
//                             PaperComponent={(paperProps) => (
//                                 <Paper {...paperProps}>
//                                     {paperProps.children}
//                                     <Box textAlign="right" p={1} borderTop="1px solid #ddd">
//                                         <Button
//                                             size="small"
//                                             onMouseDown={(e) => {
//                                                 e.preventDefault();
//                                                 e.stopPropagation();
//                                                 setOpenConsigneePopup(true);
//                                             }}
//                                         >
//                                             + Add New Consignee
//                                         </Button>
//                                     </Box>
//                                 </Paper>
//                             )}
//                         />

//                         {(src === 'from' ? shipFrom : shipTo) && (
//                             <Box mt={2} p={2} border={1} borderColor="grey.300" borderRadius={1}>
//                                 {[
//                                     ['clientname', 'Client Name'],
//                                     ['City', 'City'],
//                                     ['State', 'State'],
//                                     ['gstno', 'GST Number'],
//                                     ['mobileNo', 'Mobile'],
//                                     ['emailId', 'Email'],
//                                     ['ContactPerson', 'Contact Person'],
//                                     ['Address', 'Address']
//                                 ].map(([key, label]) => (
//                                     <Grid item size={{ xs: 12, sm: 6 }} key={key}>
//                                         <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
//                                             <Typography variant="caption" color="textSecondary" sx={{ minWidth: 100 }}>
//                                                 {label}:
//                                             </Typography>
//                                             <Typography variant="body1" sx={{ ml: 1 }}>
//                                                 {(src === 'from' ? shipFrom : shipTo)?.[key] || ''}
//                                             </Typography>
//                                         </Box>
//                                     </Grid>
//                                 ))}
//                             </Box>
//                         )}
//                     </Grid>
//                 ))}
//             </Grid>
//             {/* 
//             <Box mt={4} textAlign="right">
//                 <Button variant="contained" disabled={!shipFrom || !shipTo} onClick={handleNextClick}>
//                     Next
//                 </Button>
//             </Box> */}

//             <Snackbar open={snackOpen} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={() => setSnackOpen(false)} autoHideDuration={null}>
//                 <Alert severity="warning" onClose={() => setSnackOpen(false)} sx={{ width: '100%' }}>
//                     {snackMessage}
//                 </Alert>
//             </Snackbar>

//             <Dialog
//                 open={openConsigneePopup}
//                 fullWidth
//                 maxWidth={false}   // 🔑 IMPORTANT
//                 PaperProps={{
//                     sx: {
//                         maxWidth: "735px",
//                         width: { xs: "95%", md: "735px" },
//                         m: { xs: 0 }
//                     },
//                 }}
//                 onClose={(event, reason) => {
//                     if (reason === 'backdropClick') return;
//                     setTimeout(() => { setOpenConsigneePopup(false) }, 600)
//                 }}
//             >
//                 <DialogContent sx={{ p: { xs: 0 } }}>
//                     <ConsigneeMaster
//                         mode="add"
//                         onPopupCancel={() => setTimeout(() => { setOpenConsigneePopup(false) }, 600)}
//                         connectionString={connectionString}
//                         clientId={clientData.clientId}
//                         clientFirmName={clientData.companyName}
//                     />
//                 </DialogContent>
//             </Dialog>


//             {showCityModal && (
//                 <CityPopupModal
//                     onClose={() => setShowCityModal(false)}
//                     connectionString={connectionString}
//                     onCityAdded={c => {
//                         handleCitySelect(c);
//                         setShowCityModal(false);
//                     }}
//                 />
//             )}
//         </Paper>
//     );
// }

// src/Pages/.../ConsignerDetails.jsx
// ✅ Ship From (Consigner) — GET /api/consigner/search?q=&companyId=
//    Returns: { id, clientname, Address, gstno, City, State, mobileNo, emailId, ContactPerson }
// ✅ Ship To   (Consignee) — unchanged, uses /api/data/retrive

import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { Box, Grid, Paper, Typography, Button, TextField, CircularProgress, Autocomplete, Dialog, DialogContent, } from '@mui/material';
import { Snackbar, Alert } from '@mui/material';
import CityPopupModal from '../../../components/CityPopupModal';
import ConsigneeMaster from '../../ConsigneeMaster';
import ConsignerMaster from '../../ConsignerMaster';

export default function ConsignerDetails({ initialData = {}, connectionString, clientData, onChange }) {
    const { user, selectedCompany } = useAuth();
    const userId    = user?.UserId        || null;
    const companyId = selectedCompany?.CompId || null;
    const API       = connectionString;

    const [openConsignerPopup, setOpenConsignerPopup] = useState(false);
    // ── Ship From / To ────────────────────────────────────────────────────────
    const [shipFrom, setShipFrom] = useState(initialData?.shipFrom || null);
    const [shipTo,   setShipTo]   = useState(initialData?.shipTo   || null);

    // ── Ship From — consigner search options ──────────────────────────────────
    const [fromOptions, setFromOptions] = useState([]);
    const [fromLoading, setFromLoading] = useState(false);

    // ── Ship To — consignee options (unchanged) ───────────────────────────────
    const [toOptions, setToOptions] = useState([]);
    const [toLoading, setToLoading] = useState(false);

    // ── Popups ────────────────────────────────────────────────────────────────
    const [openConsigneePopup, setOpenConsigneePopup] = useState(false);
    const [showCityModal,      setShowCityModal]      = useState(false);
    const [snackOpen,          setSnackOpen]          = useState(false);
    const [snackMessage,       setSnackMessage]       = useState('');

    const initializedRef = useRef(false);

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red' } };
    const inputSX = { '& .MuiOutlinedInput-root':  { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }, };

    // ─────────────────────────────────────────────────────────────────────────
    // Init from initialData (edit mode)
    // ─────────────────────────────────────────────────────────────────────────
    useEffect(() => {
        if (initializedRef.current) return;

        if (initialData?.shipFrom) {
            setShipFrom(initialData.shipFrom);
            setFromOptions((prev) => prev.some((o) => o.id === initialData.shipFrom.id) ? prev : [initialData.shipFrom, ...prev] );
        }

        if (initialData?.shipTo) {
            setShipTo(initialData.shipTo);
            setToOptions((prev) => prev.some((o) => o.id === initialData.shipTo.id) ? prev : [initialData.shipTo, ...prev] );
        }

        initializedRef.current = true;
    }, [initialData]);

    // ─────────────────────────────────────────────────────────────────────────
    // Load initial Ship To options on mount (unchanged)
    // ─────────────────────────────────────────────────────────────────────────
    useEffect(() => {
        const fetchInitialToOptions = async () => {
            try {
                const res = await axios.get(`${API}/api/data/retrive`, { params: { mode: 'client', companyId, clientId: clientData.clientId }, });
                setToOptions(res.data || []);
            } catch (err) {
                console.error('Error fetching initial Ship To options:', err);
            }
        };
        fetchInitialToOptions();
    }, []);

    // ─────────────────────────────────────────────────────────────────────────
    // ✅ Ship From: search consigners by ConName
    // GET /api/consigner/search?q=<text>&companyId=<id>
    // ─────────────────────────────────────────────────────────────────────────
    const fetchFromOptions = async (q) => {
        if (!companyId) return;
        setFromLoading(true);
        try {
            const res = await axios.get(`${API}/api/consigner/search`, { params: { q: q || '', companyId }, });
            // API returns: { success, data: [{ id, clientname, Address, gstno, City, State, mobileNo, emailId, ContactPerson }] }
            setFromOptions(res.data?.data || []);
        } catch (err) {
            console.error('Error searching consigners:', err);
            setFromOptions([]);
        } finally {
            setFromLoading(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Ship To: search consignees (unchanged)
    // ─────────────────────────────────────────────────────────────────────────
    const fetchToOptions = async (q) => {
        if (!q) return;
        setToLoading(true);
        try {
            const res = await axios.get(`${API}/api/data/retrive`, { params: { mode: 'client', companyName: q, clientId: clientData.clientId, companyId }, });
            setToOptions(res.data || []);
        } catch (err) {
            console.error('Error searching consignees:', err);
        } finally {
            setToLoading(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Push data to parent on change
    // ─────────────────────────────────────────────────────────────────────────
    useEffect(() => {
        onChange?.({
            shipFrom: {
                id:            shipFrom?.id,
                clientname:    shipFrom?.clientname,
                Address:       shipFrom?.Address,
                gstno:         shipFrom?.gstno,
                City:          shipFrom?.City,
                State:         shipFrom?.State,
                mobileNo:      shipFrom?.mobileNo,
                emailId:       shipFrom?.emailId,
                ContactPerson: shipFrom?.ContactPerson,
            },
            shipTo: {
                id:            shipTo?.id,
                clientname:    shipTo?.clientname,
                Address:       shipTo?.Address,
                gstno:         shipTo?.gstno,
                City:          shipTo?.City,
                State:         shipTo?.State,
                mobileNo:      shipTo?.mobileNo,
                emailId:       shipTo?.emailId,
                ContactPerson: shipTo?.ContactPerson,
            },
        });
    }, [shipFrom?.id, shipTo?.id]);

    // ─────────────────────────────────────────────────────────────────────────
    // Detail card renderer
    // ─────────────────────────────────────────────────────────────────────────
    const renderDetails = (obj) => {
        if (!obj) return null;
        const fields = [
            ['clientname',    'Name'],
            ['Address',       'Address'],
            ['City',          'City'],
            ['State',         'State'],
            ['gstno',         'GST No.'],
            ['mobileNo',      'Mobile'],
            ['emailId',       'Email'],
            ['ContactPerson', 'Contact Person'],
        ];
        return (
            <Box mt={1.5} p={1.5} border={1} borderColor="grey.300" borderRadius={1} bgcolor="#fafafa">
                {fields.map(([key, label]) =>
                    obj[key] ? (
                        <Box key={key} display="flex" alignItems="flex-start" sx={{ mb: 0.5 }}>
                            <Typography variant="caption" color="textSecondary" sx={{ minWidth: 110, pt: '1px' }}>
                                {label}:
                            </Typography>
                            <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                                {obj[key]}
                            </Typography>
                        </Box>
                    ) : null
                )}
            </Box>
        );
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Render
    // ─────────────────────────────────────────────────────────────────────────
    return (
        <Paper sx={{ p: 1, mt: -1.5 }}>
            <Grid container spacing={2}>

                {/* ── Ship From (Consigner) ───────────────────────────────── */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="subtitle1" mb={1} fontWeight={600}>
                        Ship From (Consigner)
                    </Typography>

                    <Autocomplete fullWidth freeSolo
                        options={ shipFrom ? [shipFrom, ...fromOptions.filter((o) => o.id !== shipFrom.id)] : fromOptions }
                        getOptionLabel={(opt) => typeof opt === 'string' ? opt : opt.clientname || '' } isOptionEqualToValue={(opt, val) => opt?.id === val?.id} value={shipFrom} loading={fromLoading}
                        // ✅ Calls /api/consigner/search on every keystroke
                        onInputChange={(_, v) => fetchFromOptions(v)}
                        onChange={(_, val) => setShipFrom(val)}
                        slotProps={{ popper: { sx: { zIndex: 100 } } }}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                                <Box>
                                    <Typography variant="body2" fontWeight={600}>
                                        {option.clientname}
                                    </Typography>
                                    {(option.City || option.State) && (
                                        <Typography variant="caption" color="text.secondary">
                                            {[option.City, option.State].filter(Boolean).join(', ')}
                                        </Typography>
                                    )}
                                </Box>
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} size="small" label="Select Ship From" sx={inputSX} InputLabelProps={{ sx: requiredAsteriskStyle }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {fromLoading && <CircularProgress size={18} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                        // ✅ "Add New Consigner" button always shown at bottom of dropdown
                        PaperComponent={(paperProps) => (
                            <Paper {...paperProps}>
                                {paperProps.children}
                                <Box textAlign="right" p={1} borderTop="1px solid #ddd">
                                    <Button size="small"
                                        onMouseDown={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setOpenConsignerPopup(true);
                                        }}
                                    >
                                        + Add New Consigner
                                    </Button>
                                </Box>
                            </Paper>
                        )}
                    />

                    {renderDetails(shipFrom)}
                </Grid>

                {/* ── Ship To (Consignee) — unchanged ────────────────────── */}
                <Grid item size={{ xs: 12, sm: 6 }}>
                    <Typography variant="subtitle1" mb={1} fontWeight={600}>
                        Ship To (Consignee)
                    </Typography>

                    <Autocomplete fullWidth freeSolo
                        options={ shipTo ? [shipTo, ...toOptions.filter((o) => o.id !== shipTo.id)] : toOptions }
                        getOptionLabel={(opt) => typeof opt === 'string' ? opt : opt.clientname || '' }
                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                        value={shipTo}
                        loading={toLoading}
                        onInputChange={(_, v) => fetchToOptions(v)}
                        onChange={(_, val) => setShipTo(val)}
                        slotProps={{ popper: { sx: { zIndex: 100 } } }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                label="Select Ship To"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {toLoading && <CircularProgress size={18} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                                InputLabelProps={{ sx: requiredAsteriskStyle }}
                                sx={inputSX}
                            />
                        )}
                        PaperComponent={(paperProps) => (
                            <Paper {...paperProps}>
                                {paperProps.children}
                                <Box textAlign="right" p={1} borderTop="1px solid #ddd">
                                    <Button
                                        size="small"
                                        onMouseDown={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setOpenConsigneePopup(true);
                                        }}
                                    >
                                        + Add New Consignee
                                    </Button>
                                </Box>
                            </Paper>
                        )}
                    />

                    {renderDetails(shipTo)}
                </Grid>
            </Grid>

            {/* ── Snackbar ─────────────────────────────────────────────────── */}
            <Snackbar open={snackOpen} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={() => setSnackOpen(false)} autoHideDuration={5000} >
                <Alert severity="warning" onClose={() => setSnackOpen(false)} sx={{ width: '100%' }}>
                    {snackMessage}
                </Alert>
            </Snackbar>

            {/* ── Add Consignee popup (Ship To only — unchanged) ──────────── */}
            <Dialog
                open={openConsigneePopup}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    sx: { maxWidth: '735px', width: { xs: '95%', md: '735px' }, m: { xs: 0 } },
                }}
                onClose={(_, reason) => {
                    if (reason === 'backdropClick') return;
                    setTimeout(() => setOpenConsigneePopup(false), 600);
                }}
            >
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ConsigneeMaster
                        mode="add"
                        onPopupCancel={() => setTimeout(() => setOpenConsigneePopup(false), 600)}
                        connectionString={connectionString}
                        clientId={clientData.clientId}
                        clientFirmName={clientData.companyName}
                    />
                </DialogContent>
            </Dialog>

            {/* ── Add Consigner popup (Ship From) ─────────────────────────── */}
            <Dialog
                open={openConsignerPopup}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    sx: { maxWidth: '735px', width: { xs: '95%', md: '735px' }, m: { xs: 0 } },
                }}
                onClose={(_, reason) => {
                    if (reason === 'backdropClick') return;
                    setOpenConsignerPopup(false);
                }}
            >
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ConsignerMaster
                        mode="add"
                        connectionString={connectionString}
                        onPopupCancel={() => {
                            setOpenConsignerPopup(false);
                            // Refresh Ship From options after adding
                            fetchFromOptions('');
                        }}
                        onSaved={() => fetchFromOptions('')}
                    />
                </DialogContent>
            </Dialog>

            {/* ── City popup ──────────────────────────────────────────────── */}
            {showCityModal && (
                <CityPopupModal
                    onClose={() => setShowCityModal(false)}
                    connectionString={connectionString}
                    onCityAdded={() => setShowCityModal(false)}
                />
            )}
        </Paper>
    );
}